import React from 'react';
import PropTypes from 'prop-types';
import Switch from 'components/Switch';

const CrudSwitch = ({ input, readOnly, ...props }) => (
    <Switch checked={!!input.value} onChange={input.onChange} disabled={readOnly} {...props} />
);

CrudSwitch.propTypes = {
    input: PropTypes.shape({}).isRequired,
};

export default CrudSwitch;
